export enum AttributeCardType {
  TEXT = "TEXT",
  SELECTION = "SELECTION",
  DATE_PICKER = "DATE_PICKER",
  LOCATION = "LOCATION",
}

export enum AttributeCardDisplayVariantType {
  ACCOUNT = "account",
  ONBOARDING = "onboarding",
}
